import { render, staticRenderFns } from "./MenuLogin.vue?vue&type=template&id=04a0a315&lang=pug&"
import script from "./MenuLogin.vue?vue&type=script&lang=js&"
export * from "./MenuLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports